import React from "react";
import { useTranslation } from "react-i18next";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export default function NotFound() {
  const [t] = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="flex flex-col items-center text-center motion-safe:animate-fade-in">
        <span className="mb-4 rounded-full bg-slate-100 p-3 text-slate-400 ring-8 ring-slate-100/50">
          <MagnifyingGlassIcon className="h-6 w-6" aria-hidden="true" />
        </span>
        <div className="text-2xl font-semibold tracking-tight text-slate-900">{t("not_found.title")}</div>
      </div>
    </div>
  );
}
